<template>
  <ToastService/>
  <FileUpload name="upload[]"
              @upload="onTemplatedUpload($event)"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
              :maxFileSize="20000000"
              @select="onSelectedFiles"
  >
    <template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
      <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
        <div class="flex gap-2">
          <Button @click="chooseCallback()" icon="pi pi-file-arrow-up" rounded outlined severity="secondary"></Button>
          <Button @click="clearCallback()" icon="pi pi-times" rounded outlined severity="danger"
                  :disabled="!files || files.length === 0"></Button>
        </div>
        <ProgressBar :value="totalSizePercent" :showValue="false" class="md:w-20rem h-1 w-full md:ml-auto">
          <span class="whitespace-nowrap">{{ totalSize }}B / 20Mb</span>
        </ProgressBar>
      </div>
    </template>
    <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
      <div class="flex flex-col gap-8 pt-4">
        <div v-if="files.length > 0">
          <div class="flex flex-wrap gap-4">
            <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                 class="p-8 rounded-border flex flex-col border border-surface items-center gap-4">
              <div>
                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50"/>
              </div>
              <span class="font-semibold text-ellipsis max-w-60 whitespace-nowrap overflow-hidden">{{
                  file.name
                }}</span>
              <div>{{ formatSize(file.size) }}</div>
              <Button icon="pi pi-times" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined
                      rounded severity="danger"/>
            </div>
          </div>
        </div>

        <div v-if="uploadedFiles.length > 0">

          <div class="flex flex-wrap gap-4">
            <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size"
                 class="p-8 rounded-border flex flex-col border border-surface items-center gap-4">
              <div>
                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50"/>
              </div>
              <span class="font-semibold text-ellipsis max-w-60 whitespace-nowrap overflow-hidden">{{
                  file.name
                }}</span>
              <div>{{ formatSize(file.size) }}</div>
              <Button icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined rounded severity="danger"/>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #empty>
      <div class="flex items-center justify-center flex-col">
        <i class="pi pi-cloud-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"/>
        <p class="mt-6 mb-0">{{ $root.trans.drag_and_drop_files_to_here_to_upload }}</p>
      </div>
    </template>
  </FileUpload>
  <hr class="my-8 border-t border-gray-200">
  <FormInput :dati='mapped'
             :idform="mapping_import"
             :action="azioni"
             ref="input">
  </FormInput>
  <div class="w-full">
    <div class="flex items-center justify-between mb-2">
      <div class="text-sm text-gray-500">{{ $root.trans.campi_obbligatori_asterisco }}</div>
      <div class="container-istruzioni-import">
      <Button @click="downloadSampleCsv(sampleData)" icon="pi pi-download" :label="$root.trans.scarica_csv_esempio"
              severity="primary"/>
      <div>{{ istruzioni }}</div>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-4 mb-4 font-bold bg-gray-100 p-2">
      <div>{{ $root.trans.colonne_richieste }}</div>
      <div>{{ $root.trans.colonne_file }}</div>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <template v-for="(dbCol, index) in colonne_import" :key="index">
        <div class="flex items-center">
          <span class="text-sm font-medium">{{
              dbCol.title.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
            }}{{ isRequired(dbCol.field) ? ' *' : '' }}</span>
        </div>
        <div class="flex items-center">
          <select class="form-select w-full" v-model="columnMappings[dbCol.field]">
            <option :disabled="isRequired(dbCol.field)" value="non_presente">{{ $root.trans.non_presente }}</option>
            <option v-for="(col, colIndex) in columns" :key="colIndex" :value="col"
                    :disabled="Object.values(columnMappings).includes(col) && columnMappings[dbCol.field] !== col">
              {{ col }}
            </option>
          </select>
        </div>
      </template>
    </div>

    <div class="flex flex-col gap-2 mt-4">
      <div v-if="checkbox_title" class="flex items-center">
        <input type="checkbox" id="checkbox" v-model="checkboxSelezionata" class="form-checkbox h-5 w-5 text-blue-600">
        <label for="checkbox" class="ml-2 text-gray-700">{{ checkbox_title }}</label>
      </div>
      <div class="flex-col justify-end" v-if="idform">
        <SingleForm
          :id="idform"
          :dati="dati"
          :struttura="struttura"
          :file_key="file_key"
          :accept-files="true"
          :hide-buttons="true"
          ref="singleForm"
        >
        </SingleForm>
      </div>
      <div class="flex justify-end">
        <Button @click="uploadEvent() " icon="pi pi-cloud-upload" :label="$root.trans.carica_file" severity="primary"
                :disabled="!files || files.length === 0 || !hasValidMapping"></Button>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import ToastService from 'primevue/toastservice';
import FileUpload from 'primevue/fileupload';
import FloatLabel from 'primevue/floatlabel';
import Select from 'primevue/select';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Badge from 'primevue/badge';
import * as XLSX from 'xlsx';
import FormInput from "./FormInput.vue";
import {useToast} from "primevue/usetoast";
import SingleForm from "./SingleForm.vue";


export default {
  name: "FileMultiploUpload",
  props: {
    azioni: {},
    dati: {
      type: [String, Object, Array],
      required: true,
      default: () => []
    },
    struttura: {
      type: [String, Object, Array],
      required: true,
      default: () => []
    },
    file_key: {
      type: String,
      required: true,
      default: 'file'
    },
    istruzioni: {
      type: String,
      required: false,
      default: ''
    },
    idform: {},
    sample_data: {},
    route_params: {},
    redirect_route: {},
    route_credenziali: {},
    colonne_import: {},
    required_columns: {},
    checkbox_title: String
  },
  components: {
    SingleForm,
    FormInput,
    ToastService,
    FileUpload,
    FloatLabel,
    Select,
    Dialog,
    Button,
    Badge,
  },
  data() {
    console.log('Dati:', this.dati);
    return {
      localDati: typeof this.dati === 'string' ? JSON.parse(this.dati) : this.dati,
      localStruttura: typeof this.struttura === 'string' ? JSON.parse(this.struttura) : this.struttura,
      localFileKey: this.file_key,
      showModal: [],
      errors: [],
      totalSize: 0,
      totalSizePercent: 0,
      files: [],
      columnMappings: {},
      columns: [],
      istruzioni: this.istruzioni,
      checkboxSelezionata: false,
      sampleData: this.sample_data,
    };
  },
  computed: {
    uploadUrl() {
      return route(this.azioni, this.route_params);
    },
    hasValidMapping() {
      return Object.keys(this.columnMappings).length === this.colonne_import.length;
    },
    isRequired() {
      return (field) => this.required_columns && this.required_columns.includes(field);
    }
  },
  methods: {
    downloadSampleCsv(sampleData = null) {
      const headers = this.colonne_import.map(col => `"${col.title}"`);
      let csvContent = headers.join(',');

      if (sampleData && typeof sampleData === 'object') {
        const sampleRow = this.colonne_import.map(col => {
          const value = sampleData[col.field] || sampleData[col.title] || '';
          const escapedValue = String(value).replace(/"/g, '""');
          return escapedValue.includes(',') || escapedValue.includes('"') || escapedValue.includes('\n')
            ? `"${escapedValue}"`
            : escapedValue;
        });

        csvContent += '\n' + sampleRow.join(',');
      }

      const blob = new Blob([csvContent], {type: 'text/csv'});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'example.csv';
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onRemoveTemplatingFile(file, removeFileCallback, index) {
      removeFileCallback(index);
      this.totalSize -= file.size;
      this.totalSizePercent = this.totalSize / 10;


      this.colonne_import.forEach(colonna => {
        this.columnMappings[colonna.field] = "";
      });

      this.columns = [];

      this.$emit('file-rimosso', file.name);
    },
    onClearTemplatingUpload(clear) {
      clear();
      this.totalSize = 0;
      this.totalSizePercent = 0;
    },
    onSelectedFiles(event) {
      this.files = event.files;
      this.totalSize = 0;
      this.files.forEach((file) => {
        this.totalSize += parseInt(this.formatSize(file.size));
      });
      if (this.files.length > 0) {
        this.extractFileColumns(this.files[0]);
      }
    },
    extractFileColumns(file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (fileExtension === 'csv') {
        const reader = new FileReader();
        reader.onload = (e) => {
          const text = e.target.result;
          const lines = text.split('\n');
          const headers = lines[0].split(',').map(col =>
            col.replace(/"/g, '').trim()
          );
          console.log('Headers CSV:', headers);

          this.columns = headers.map(col => {
            return String(col)
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
          });

          this.$nextTick(() => {
            this.autoMapColumns();
          });

          this.$emit('colonne-caricate', this.columns);
        };
        reader.readAsText(file, 'UTF-8');

      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, {
            type: 'array',
            codepage: 65001 // UTF-8
          });
          const firstSheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, {header: 1});

          console.log('Headers Excel:', rows[0]);

          this.columns = rows[0].map(col => {
            return String(col)
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
          });

          this.$nextTick(() => {
            this.autoMapColumns();
          });
          this.$emit('colonne-caricate', this.columns);
        };
        reader.readAsArrayBuffer(file);
      }
    },
    async uploadEvent() {
      if (!this.uploadUrl || !this.hasValidMapping) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: this.$root.trans.import_failed_invalid_url_or_mapping,
          life: 3000
        });
        return;
      }

      const columnMap = Object.entries(this.columnMappings).reduce((result, [dbCol, fileCol]) => {
        if (fileCol) {
          result.push({colonna_db: dbCol, colonna_file: fileCol});
        }
        return result;
      }, []);

      let formData = new FormData();
      formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
      for (let i = 0; i < this.files.length; i++) {
        formData.append('upload[]', this.files[i]);
      }
      formData.append('column_map', JSON.stringify(columnMap));
      formData.append('checkbox_selezionata', this.checkboxSelezionata);

      if (this.$refs.singleForm) {
        const errorValidazione = await this.$refs.singleForm.validate(3);

        if(errorValidazione){
          return;
        }
          const formInfo = this.$refs.singleForm.$refs.input;
          formData.append('info_select', JSON.stringify(formInfo.info));

          if (formInfo.files) {
            const filesArray = Object.values(formInfo.files);
            filesArray.forEach((file, index) => {
              console.log('File:', (file instanceof File));
              if (file instanceof File) {
                formData.append(`single_form_files[${index}]`, file);
              }
            });
          }
      }
      axios.post(this.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: this.$root.trans.dati_importati_correttamente,
            life: 2500
          });
          const hasCredenziali = response.data.credenziali_import && Object.keys(response.data.credenziali_import).length > 0;


          setTimeout(() => {
            if (hasCredenziali) {
              window.location = route('dipendenti/import/credenziali');
            } else {
              window.location = route(this.redirect_route);
            }
          }, 3000);
        })

    },
    onTemplatedUpload() {
      this.$toast.add({severity: "info", summary: "Success", detail: "File Uploaded", life: 3000});
    },
    formatSize(bytes) {
      const k = 1024;
      const dm = 3;
      const sizes = ["B", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return `0 ${sizes[0]}`;
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    normalizeForComparison(str) {
      return String(str)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    levenshteinDistance(str1, str2) {
      const matrix = [];

      for (let i = 0; i <= str2.length; i++) {
        matrix[i] = [i];
      }

      for (let j = 0; j <= str1.length; j++) {
        matrix[0][j] = j;
      }

      for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
          if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1, // substitution
              matrix[i][j - 1] + 1,     // insertion
              matrix[i - 1][j] + 1      // deletion
            );
          }
        }
      }

      return matrix[str2.length][str1.length];
    },
    calculateSimilarity(str1, str2) {
      const normalized1 = this.normalizeForComparison(str1);
      const normalized2 = this.normalizeForComparison(str2);

      if (normalized1 === normalized2) {
        return 1;
      }

      if (normalized1.includes(normalized2) || normalized2.includes(normalized1)) {
        return 0.9;
      }

      const maxLength = Math.max(normalized1.length, normalized2.length);
      if (maxLength === 0) return 1;

      const distance = this.levenshteinDistance(normalized1, normalized2);
      return (maxLength - distance) / maxLength;
    },
    findBestMatch(dbColumnTitle, fileColumns) {
      let bestMatch = null;
      let bestScore = 0;

      fileColumns.forEach(fileCol => {
        const similarity = this.calculateSimilarity(dbColumnTitle, fileCol);
        if (similarity > bestScore && similarity >= 0.7) {
          bestScore = similarity;
          bestMatch = fileCol;
        }
      });

      return bestMatch;
    },
    autoMapColumns() {
      this.colonne_import.forEach(dbCol => {
        const bestMatch = this.findBestMatch(dbCol.title, this.columns);
        if (bestMatch && !Object.values(this.columnMappings).includes(bestMatch)) {
          this.columnMappings[dbCol.field] = bestMatch;
        }
      });
    },
    checkModale: function (key, is_multi_select = false) {
      var vm = this.$refs['modalinput_' + key][0];
      var vm_father = this;
      var b = false;

      for (const [key, value] of Object.entries(vm.label)) {
        if (typeof value[2] != "undefined" && value[2] !== "") {
          if (value[2].includes('|') === false) {
            if (value[2].includes(':')) {
              var key_c = index.split(":");
              if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                b = true;
              }
            } else {
              if (vm.inputValidation(key, null, value[2], value[1], value[0])) {
                b = true;
              }
            }
          } else {
            var array_validazioni = value[2].split("|");
            array_validazioni.forEach((index) => {
              if (index.includes(':')) {
                var key_c = index.split(":");
                if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                  b = true;
                }
              } else {
                if (vm.inputValidation(key, null, index, value[1], value[0])) {
                  b = true;
                }
              }
            });
          }
        }
      }

      if (!b) {
        try {
          axios.post(vm.action, vm.info)
            .then(function (response) {
              if (response.data.success) {
                vm_father.label[key][3].push(response.data.value);
                if (!is_multi_select) {
                  vm_father.info[key] = response.data.value.id;
                } else {
                  vm_father.info[key].push(response.data.value.id)
                }

                vm_father.showModal[key] = false
              } else {
                this.$toast.add({
                  severity: 'errors',
                  summary: this.$root.trans.errors_form,
                  detail: this.$root.trans.salvataggio_errato,
                  life: 3000
                });
              }
            }.bind(this));
        } catch (error) {
          if (error.response && error.response.status === 401) {
            this.$toast.add({
              severity: 'errors',
              summary: this.$root.trans.errors_form,
              detail: this.$root.trans.salvataggio_errato,
              life: 3000
            });
          }
        }
      }
    },

  }
};
</script>

<style scoped>
hr {
  width: 100%;
}
</style>